/* South Central Archive — storefront behavior */
(function () {
  'use strict';

  // ─── CART DRAWER ────────────────────────────────────────────
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('[data-cart-backdrop]');
  const body = document.querySelector('[data-cart-body]');
  const foot = document.querySelector('[data-cart-foot]');
  const countEl = document.querySelector('[data-cart-count]');
  const countText = document.querySelectorAll('[data-cart-count-text]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    backdrop && backdrop.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop && backdrop.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openDrawer(); }
    else if (e.target.closest('[data-cart-close]') || e.target.matches('[data-cart-backdrop]')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ─── CART AJAX ──────────────────────────────────────────────
  function setLoading(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-loading', on);
  }
  function fetchSections() {
    return fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
      .then((r) => r.ok ? r.json() : null)
      .catch(() => null);
  }
  function refreshDrawer() {
    setLoading(true);
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.hidden = cart.item_count === 0;
        }
        countText.forEach((el) => { el.textContent = cart.item_count; });
        // Re-render drawer body via section render
        return fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const newBody = doc.querySelector('[data-cart-body]');
            const newFoot = doc.querySelector('[data-cart-foot]');
            if (newBody && body) body.innerHTML = newBody.innerHTML;
            if (newFoot && foot) {
              foot.innerHTML = newFoot.innerHTML;
              foot.hidden = cart.item_count === 0;
            }
            setLoading(false);
            return cart;
          });
      })
      .catch(() => setLoading(false));
  }

  function addToCart(form) {
    const fd = new FormData(form);
    const btn = form.querySelector('[data-add-to-cart]');
    const lbl = form.querySelector('[data-add-label]');
    const prev = lbl ? lbl.textContent : '';
    if (lbl) lbl.textContent = 'Adding…';
    if (btn) btn.setAttribute('aria-disabled', 'true');
    return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then((r) => r.json())
      .then((res) => {
        if (res.status) { throw res; }
        if (lbl) lbl.textContent = 'Added ✓';
        return refreshDrawer().then(() => { openDrawer(); });
      })
      .catch((err) => {
        if (lbl) lbl.textContent = err && err.description ? err.description : 'Unavailable';
      })
      .finally(() => {
        if (btn) btn.removeAttribute('aria-disabled');
        setTimeout(() => { if (lbl) lbl.textContent = prev; }, 1800);
      });
  }

  document.addEventListener('submit', function (e) {
    const form = e.target.closest('[data-product-form]');
    if (form) {
      e.preventDefault();
      addToCart(form);
    }
  });

  function changeLine(key, qty) {
    setLoading(true);
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(() => refreshDrawer());
  }

  document.addEventListener('click', function (e) {
    const incBtn = e.target.closest('[data-cart-qty]');
    if (incBtn) {
      const key = incBtn.dataset.key;
      const input = document.querySelector(`[data-cart-qty-input][data-key="${key}"]`);
      if (!input) return;
      let q = parseInt(input.value, 10) || 0;
      q += incBtn.dataset.cartQty === 'inc' ? 1 : -1;
      if (q < 0) q = 0;
      input.value = q;
      changeLine(key, q);
    } else if (e.target.closest('[data-cart-remove]')) {
      const key = e.target.closest('[data-cart-remove]').dataset.key;
      changeLine(key, 0);
    }
  });
  document.addEventListener('change', function (e) {
    const input = e.target.closest('[data-cart-qty-input]');
    if (input) {
      let q = parseInt(input.value, 10);
      if (isNaN(q) || q < 0) q = 0;
      changeLine(input.dataset.key, q);
    }
  });

  // ─── PDP: thumb gallery + variant picker ────────────────────
  const heroImg = document.getElementById('pdp-hero-img');
  document.addEventListener('click', function (e) {
    const t = e.target.closest('[data-pdp-thumb]');
    if (t && heroImg) {
      document.querySelectorAll('[data-pdp-thumb]').forEach((b) => b.classList.remove('is-active'));
      t.classList.add('is-active');
      heroImg.src = t.dataset.src;
    }
  });

  // Variant picker: rebuild selected variant from chosen option values.
  const variantJsonEl = document.querySelector('[data-product-json]');
  if (variantJsonEl) {
    let variants = [];
    try { variants = JSON.parse(variantJsonEl.textContent); } catch (e) {}
    const variantInput = document.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-pdp-price]');
    const addBtn = document.querySelector('[data-add-to-cart]');
    const addLbl = document.querySelector('[data-add-label]');

    function selectedOptions() {
      const opts = [];
      document.querySelectorAll('.pdp__option').forEach((group) => {
        const active = group.querySelector('.pdp__option-val.is-active');
        if (active) opts.push(active.dataset.optionValue);
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find((v) =>
        v.options.every((o, i) => o === opts[i])
      );
    }
    function fmtMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function update() {
      const opts = selectedOptions();
      const v = findVariant(opts);
      if (!v) return;
      variantInput.value = v.id;
      if (priceEl) {
        let html = '';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<del>' + fmtMoney(v.compare_at_price) + '</del> ';
        }
        html += fmtMoney(v.price);
        priceEl.innerHTML = html;
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addLbl.textContent = 'Add to cart'; }
        else { addBtn.setAttribute('disabled', ''); addLbl.textContent = 'Sold out'; }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.pdp__option-val');
      if (!btn) return;
      const group = btn.closest('.pdp__option');
      group.querySelectorAll('.pdp__option-val').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      update();
    });
  }
})();
